import React from 'react';

/**
 * Warning Triangle Icon Component
 * @description A warning triangle icon with exclamation mark, used for displaying warnings and alerts
 */
export const WarningTriangleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M13 14h-2V9h2m0 9h-2v-2h2M1 21h22L12 2z" />
  </svg>
);

export default WarningTriangleIcon;

